module.exports = __webpack_public_path__ + "static/assets/c102ba4a6efab67e215e7d102fe2b893.svg";